import { bindActionCreators, Dispatch, Action } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  logisticsInfoSelector,
  invoiceInitialAddressSelector,
} from '@/checkout-instore-legacy/shipping/selectors'
import { countryCodeSelector } from '@/checkout-instore-legacy/order/selectors'
import InvoiceAddress from '../components/InvoiceAddress'
import { sendInvoiceAddress } from '../actions'

export const mapStateToPropsSelector = createStructuredSelector({
  initialAddress: invoiceInitialAddressSelector,
  logisticsInfo: logisticsInfoSelector,
  countryCode: countryCodeSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ sendInvoiceAddress }, dispatch)

export default connect(mapStateToPropsSelector, mapDispatchToProps, undefined, {
  forwardRef: true,
})(InvoiceAddress)
